import { ReactNode } from 'react';

import { Header } from '@/layout/header/Header';
import { PartnerNavSidebar } from './PartnerNavSidebar';
import { RouteErrorBoundary } from '@/components/error-boundary';
import { useLanguageInitialization } from '@/hooks/useLanguageInitialization';

interface PartnerLayoutProps {
  children: ReactNode;
}

export function PartnerLayout({ children }: PartnerLayoutProps) {
  // The partner area bypasses SlugLayout, which is where the customer app
  // applies the user's language — without this a partner keeps whatever the
  // browser detector picked, never their own preference.
  useLanguageInitialization();

  return (
    <div className="flex flex-col h-screen bg-sidebar">
      <Header />
      <div className="flex flex-1 min-h-0">
        <PartnerNavSidebar />
        <main className="flex-1 mb-4 mr-4 overflow-auto border bg-background rounded-2xl border-border">
          <RouteErrorBoundary>{children}</RouteErrorBoundary>
        </main>
      </div>
    </div>
  );
}
